import axios, { HttpStatusCode } from "axios";

const axiosHttpReferesh = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

let accessToken = null;

export const setAuthToken = (token) => {
  accessToken = token;
};


// Request Interceptor (Optional)
axiosHttpReferesh.interceptors.request.use(
  (config) => {
    // Use module-level accessToken if already set, otherwise fall back to localStorage.
    // On hard refresh, setAuthToken() may not have been called yet before refreshToken()
    // fires, so accessToken is still null — localStorage is the only source in that case.
    const token = accessToken || localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    if (token || userId) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers["x-access-token"] = token;
      config.headers["user_id"] = userId;
    }
    return config;
  },
  (error) => {
    return Promise.reject({
      message: "Request error occurred",
      status: HttpStatusCode.InternalServerError,
      ...(error?.request || {}),
    });
  }
);

// Response Interceptor
axiosHttpReferesh.interceptors.response.use(
  (response) => {
    if (response.status >= HttpStatusCode.Ok && response.status <= 299) {
      return (
        response.data || {
          error: false,
          data: [],
          message: "",
        }
      );
    } else {
      const errorData = response?.data || {
        error: true,
        status: response.status,
        data: [],
        message: "API error occurred",
      };
      return Promise.reject(errorData);
    }
  },
  (error) => {
    const backendMessage = error.response?.data?.message || error.response?.data?.error || "Response error occurred";
    return Promise.reject({
      message: backendMessage,
      status: error.response?.status || HttpStatusCode.InternalServerError,
      ...(error?.response || {}),
    });
  }
);

export default axiosHttpReferesh;
